import createCache from '@emotion/cache'
import { createTheme } from '@mui/material/styles'

// Separate Emotion cache so MUI v5 styles don't interfere with MUI v3
export const emotionCache = createCache({
  key: 'muiv',
  prepend: true,
})

// MUI v5 theme that matches the site's existing dark theme
export const organizationsTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#9EC73E',
    },
    background: {
      default: '#282828',
      paper: '#31353D',
    },
    text: {
      primary: '#fff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { backgroundImage: 'none' },
      },
    },
  },
})
